import { useEffect, useState } from "react";

export function useInViewOnce(ref, options = { threshold: 0.12 }) {
    const [inView, setInView] = useState(false);
    useEffect(() => {
        if (!ref.current) return;
        const obs = new IntersectionObserver((entries) => {
            entries.forEach(e => {
                if (e.isIntersecting) {
                    setInView(true);
                    obs.disconnect();
                }
            });
        }, options);
        obs.observe(ref.current);
        return () => obs.disconnect();
    }, [ref, JSON.stringify(options)]);
    return inView;
}
